<mat-drawer-container class="main-drawer-container" hasBackdrop="false">
  <mat-drawer
    #drawer
    mode="over"
    class="main-drawer"
    opened="true"
    [ngClass]="panels.hide ? 'hidePanels' : ''">
    <app-vertical-menu (panelTitle)="setPanel($event)"></app-vertical-menu>

    <div class="side-nav-panel-router-wrap">
      <mat-toolbar class="side-nav-panel-headers-toolbar">
        <mat-toolbar-row>
          <span [hidden]="panels.hide">{{ panelTitle }}</span>
          <span class="example-spacer"></span>
          <button
            [hidden]="panels.hide"
            mat-icon-button
            aria-label="close"
            (click)="changePanel('hide')">
            <mat-icon>chevron_left</mat-icon>
          </button>
        </mat-toolbar-row>
      </mat-toolbar>

      <app-dispatch *ngIf="panels.dispatch"></app-dispatch>
      <app-outbound *ngIf="panels.outbound"></app-outbound>
      <app-manage-vans *ngIf="panels.manageVans"></app-manage-vans>
      <app-my-tasks *ngIf="panels.myTasks"></app-my-tasks>
      <app-profile  *ngIf="panels.profile" (hidePanel)="changePanel('hide')"></app-profile>
      <app-settings *ngIf="panels.settings"></app-settings>
      <app-unassigned-tasks *ngIf="panels.unassignedTasks"></app-unassigned-tasks>
      <app-new-task *ngIf="panels.newTask" (hidePanel)="changePanel('hide')"></app-new-task>
      <app-search *ngIf="panels.search"></app-search>
      <app-terminal-runs *ngIf="panels.terminalruns"></app-terminal-runs>
    </div>
  </mat-drawer>

  <mat-drawer #drawer1 mode="over" position="end" class="alerts-drawer">
    <app-alerts></app-alerts>
  </mat-drawer>

  <mat-drawer-content>
    <div class="map-container">
      <div class="map-frame">
        <div id="map" #map></div>
      </div>
    </div>
  </mat-drawer-content>
</mat-drawer-container>
